<div class="cta-heading" *ngIf="ctaData">
    <div class="title {{ctaData.ctaClass}}"
        *ngIf="ctaData.title"
        [ngClass]="{'hero-shadow': ctaData.shadowEnabled}"
        [innerHtml]="ctaData.title">
    </div>
    <div class="subtitle {{ctaData.ctaClass}}"
        *ngIf="ctaData.subtitle"
        [ngClass]="{'hero-shadow': ctaData.shadowEnabled}"
        [innerHtml]="ctaData.subtitle">
    </div>
</div>
